<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" md="8" lg="6">
        <v-card elevation="3" rounded="lg" class="pa-6 text-center">
          <v-icon size="64" color="warning">
            mdi-alert-circle-outline
          </v-icon>

          <h1 class="text-h5 font-weight-light mt-4 mb-3">
            A DivZero liberou uma oferta que pode facilitar bastante a sua
            negociação:
            <br /><br />
            💰 Entrada com valor reduzido<br />
            📆 Parcelamento em até 60x<br />
            ✅ Condições especiais para você<br /><br />
            Escolha um dos canais abaixo e fale conosco agora mesmo!
          </h1>

          <v-divider class="mb-6"></v-divider>

          <v-card
            outlined
            class="pa-6 text-center"
            style="border-radius: 12px;"
          >
            <div class="grey--text text--darken-1 mb-3">
              Escolha um dos canais abaixo:
            </div>

            <div
              style="justify-content: center; gap:20px;"
              class="d-flex flex-row align-center"
            >
              <!-- WhatsApp - principal -->
              <a
                href="https://esycb.me/SITE"
                target="_blank"
                class="whatsapp-button"
              >
                <img
                  src="@/assets/login/whatsapp_ti.png"
                  width="48"
                  title="WhatsApp"
                />
                <br />
                <span style=" margin-top:10px;">WhatsApp</span>
              </a>

              <!-- Telegram - secundário -->
              <a
                href="https://t.me/Easycob_bot"
                target="_blank"
                class="telegram-button"
              >
                <img
                  src="@/assets/login/telegram_ti.png"
                  width="48"
                  title="Telegram"
                />
                <span style=" display:flex;">Telegram</span>
              </a>
            </div>
            <div
              class="text-overline grey--text text--darken-1 mb-2"
              style="letter-spacing: 3px;"
            >
              CENTRAL DE ATENDIMENTO
            </div>

            <div class="text-h5 font-weight-bold primary--text">
              <a href="tel:22064883"> {{ telefone }} </a>
            </div>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { atualizarLogNegoc } from "@/conf/logNegoc";
export default {
  name: "ContatoPage",
  data() {
    return {
      telefone: "(21) 2206 - 4883",
    };
  },
  async mounted() {
    let logNegoc = this.$store.state.logNegoc;
    logNegoc.log_status = `cpf ${logNegoc.cpf} entrou na página de aviso para ligar`;
    logNegoc.credor = "DIVZERO";
    logNegoc.cgc = "50510071000102";
    await atualizarLogNegoc(logNegoc);

    await this.$store.dispatch("setMostraBotoes", {
      imprimir: false,
      voltar: false,
    });
    /*
    if (this.$store.state.credor_atual == "DI SANTINNI DSCARD") {
      this.telefone = "(21) 2206- 4886";
    } */
  },
};
</script>
